(function () {
  angular.module('MktzapApp.Controllers')
    .controller('ChatBotConfigsController', chatBotConfigsController);

  chatBotConfigsController.$inject = ['$scope', '$window', 'FoundationApi', 'ChatBotConfigsService', 'NotificationService'];

  function chatBotConfigsController ($scope, $window, FoundationApi, ChatBotConfigsService, NotificationService) {
    var vm = this;
    vm.titleChatBot = 'ChatBot';
    vm.chatBotConfigs = {};
    vm.params = {};

    vm.searchConfigsTable = searchConfigsTable;
    vm.updateObject = updateObject;

    searchConfigsTable();

    function searchConfigsTable () {
      ChatBotConfigsService
        .getAllFiltered(vm.params)
        .$promise
        .then(function (data) {
          if (data) {
            vm.chatBots = data;
          } else {
            NotificationService.errorHandler(data, 'Erro ao carregar configurações do ChatBot!');
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao carregar configurações do ChatBot!');
        });
    }

    function updateObject () {
      if (vm.chatBotConfigs.configs !== '') {
        try {
          $scope.configs = JSON.parse(vm.chatBotConfigs.configs);
          $scope.formatting = { color: 'green', 'background-color': '#d0e9c6' };
          vm.chatBotConfigsValid = true;
        } catch (e) {
          $scope.formatting = { color: 'red', 'background-color': '#f2dede' };
          vm.chatBotConfigsValid = false;
        }
      } else {
        $scope.formatting = {};
      }
    }

    vm.add = function () {
      document.getElementById('scriptMongoDB').readOnly = false;
      vm.chatBotConfigs = {};
      FoundationApi.publish('chatBotConfigsModal', 'open');
    }

    vm.save = function () {
      if (vm.chatBotConfigs._id) {
        ChatBotConfigsService
          .update(
            { id: vm.chatBotConfigs._id },
            vm.chatBotConfigs
          )
          .$promise
          .then(function (data) {
            searchConfigsTable();
            if (data.success) {
              NotificationService.successHandler(data, 'Configuração do ChatBot atualizada com sucesso!');
              FoundationApi.publish('chatBotConfigsModal', 'close');
            } else {
              NotificationService.errorHandler(data, data.message);
            }
          }).catch(function (data) {
            NotificationService.errorHandler(data, 'Erro ao atualizar Configuração do ChatBot!');
          })
      } else {
        ChatBotConfigsService
          .create(vm.chatBotConfigs)
          .$promise
          .then(function (data) {
            searchConfigsTable();
            if (data.success) {
              NotificationService.successHandler(data, 'Configuração do ChatBot salva com sucesso!');
              FoundationApi.publish('chatBotConfigsModal', 'close');
            } else {
              NotificationService.errorHandler(data, data.message);
            }
          }).catch(function (data) {
            NotificationService.errorHandler(data, 'Erro ao salvar Configuração do ChatBot!');
          })
      }
    }

    vm.edit = function (chatBotConfigId, configs) {
      document.getElementById('scriptMongoDB').readOnly = false;
      ChatBotConfigsService
        .getById({ id: chatBotConfigId })
        .$promise
        .then(function (data) {
          vm.chatBotConfigs = data;
          vm.chatBotConfigs.configs = JSON.stringify(configs, null, 2);
          FoundationApi.publish('chatBotConfigsModal', 'open');
          updateObject();
        }).catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao buscar Configuração do ChatBot!');
        })
    }

    vm.delete = function (chatBotConfigId) {
      var confirmation = $window.confirm('Deseja realmente deletar?');
      if (confirmation) {
        ChatBotConfigsService
          .delete({
            id: chatBotConfigId
          })
          .$promise
          .then(function (data) {
            searchConfigsTable();
            NotificationService.successHandler(data, 'Configuração deletada com sucesso');
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, 'Erro ao deletar configuração');
          });
      }
    }
  }
})();
